// extracted by mini-css-extract-plugin
export default {"self-introduction":"SelfIntroduction_self-introduction__g+db+","name":"SelfIntroduction_name__SPtld"};